import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Button,
  Typography,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import FlipCameraIosIcon from "@mui/icons-material/FlipCameraIos";

import { useNavigate } from "react-router-dom";


import api from "../api/axiosConfig";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";




const MAX_SECONDS = 30;
const HOLD_THRESHOLD = 250;
const SIDE_CONTROLS_VISIBLE_MS = 10000;

function PostPage() {

  

  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);
  const timerRef = useRef(null);
  const holdTimeoutRef = useRef(null);
  const videoTrackRef = useRef(null);
  const sideControlsTimerRef = useRef(null);
  const fileInputRef = useRef(null);
  const [ready, setReady] = useState(false);



  const [mode, setMode] = useState("camera");
  const [mediaFile, setMediaFile] = useState(null);
  const [previewURL, setPreviewURL] = useState("");
  const [mediaKind, setMediaKind] = useState(null);
  const [recording, setRecording] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(MAX_SECONDS);
  const [facingMode, setFacingMode] = useState("user");
  
  const [showSideControls, setShowSideControls] = useState(true);

  const [message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

const [city, setCity] = useState(null);
const [streetAddress, setStreetAddress] = useState(null);


  const [loading, setLoading] = useState(false);
  const [lat, setLat] = useState(null);
const [lng, setLng] = useState(null);
const [myCourses, setMyCourses] = useState([]);
const [selectedCourseId, setSelectedCourseId] = useState(""); // empty = no course tag

const LOCATION_CACHE_KEY = "lastStableLocation";
const LOCATION_TTL = 45 * 60 * 1000; // 45 minutes


const rawUser = localStorage.getItem("user");
const currentUser = rawUser ? JSON.parse(rawUser) : null;

useEffect(() => {
  if (!currentUser?.id) return;

  api
    .get(`/users/${currentUser.id}/courses`)
    .then((res) => setMyCourses(res.data.courses || []))
    .catch((err) => {
      console.error("❌ Failed to load user courses", err);
      setMyCourses([]);
    });
  // eslint-disable-next-line
}, []);


  const navigate = useNavigate();


  const extractCity = (components) => {
  return (
    components.find(c => c.types.includes("locality"))?.long_name ||
    components.find(c => c.types.includes("postal_town"))?.long_name ||
    components.find(c => c.types.includes("administrative_area_level_2"))?.long_name ||
    components.find(c => c.types.includes("administrative_area_level_1"))?.long_name ||
    null
  );
};
const extractStreetAddress = (results) => {
  const street = results.find(r =>
    r.types.includes("street_address") ||
    r.types.includes("premise") ||
    r.types.includes("subpremise")
  );

  const route = results.find(r => r.types.includes("route"));

  return street?.formatted_address || route?.formatted_address || null;
};




  /* =======================
   ⬅️ HANDLE BACK BUTTON
======================= */



  /* =======================
     🔒 LOCK BODY SCROLL
  ======================= */
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalTouch = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.touchAction = originalTouch;
    };
  }, []);

  

  /* =======================
     📍 LOCATION
  ======================= */
  useEffect(() => {
    if (!ready) return;
  // 1️⃣ Try cached location first
  const cached = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY));
      if (
        cached &&
        cached.streetAddress &&
        cached.city &&
        Date.now() - cached.timestamp < LOCATION_TTL
      ) {
        setLat(cached.lat);
        setLng(cached.lng);
        setCity(cached.city);
        setStreetAddress(cached.streetAddress);
        return;
      }


  // 2️⃣ Collect multiple GPS readings for accuracy
  let readings = [];
  let watchId = null;

  const finalizeLocation = (lat, lng) => {
  setLat(lat);
  setLng(lng);

  if (!window.google?.maps) {
    setCity(null);
    return;
  }

  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode(
    { location: { lat, lng } },
    (results, status) => {
      if (status === "OK" && results?.length) {
       

      } else {
        setCity(null);
      }

      // cache ONLY real results
      const street = extractStreetAddress(results);
        const resolvedCity = extractCity(results[0].address_components);

        // REQUIRE full street + city
        if (resolvedCity) {
          setCity(resolvedCity);
        }

        if (street) {
          setStreetAddress(street);
        }


        setStreetAddress(street);
        setCity(resolvedCity);

        // cache ONLY valid data
        localStorage.setItem(
          LOCATION_CACHE_KEY,
          JSON.stringify({
            lat,
            lng,
            city: resolvedCity,
            streetAddress: street,
            timestamp: Date.now(),
          })
        );

            }
          );
        };




  watchId = navigator.geolocation.watchPosition(
  (pos) => {
    const { latitude, longitude, accuracy } = pos.coords;

    // ✅ FIRST FIX (fast UI)
    if (readings.length === 0) {
      finalizeLocation(latitude, longitude);
    }

    // ✅ Keep refining accuracy (don’t block)
    if (accuracy <= 100) {
      readings.push({ latitude, longitude });
    }

    if (readings.length >= 3) {
      navigator.geolocation.clearWatch(watchId);

      const avgLat =
        readings.reduce((s, c) => s + c.latitude, 0) / readings.length;
      const avgLng =
        readings.reduce((s, c) => s + c.longitude, 0) / readings.length;

      finalizeLocation(avgLat, avgLng);
    }
  },
  () => {},
  {
    enableHighAccuracy: true,
    maximumAge: 10000,
    timeout: 8000,
  }
);


  return () => {
    if (watchId) navigator.geolocation.clearWatch(watchId);
  };
}, [ready]);



  /* =======================
     🎥 CAMERA
  ======================= */
  const stopCamera = () => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    videoTrackRef.current = null;
    
  };

  const handleExit = () => {
  stopCamera();
  navigate("/app", { replace: true }); // ✅ FORCE unmount
};




  const startCamera = async (facing = facingMode, withAudio = false) => {

    stopCamera();

    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: facing },
     audio: withAudio,

    });

    streamRef.current = stream;
    videoTrackRef.current = stream.getVideoTracks()[0];
    setMode("camera");

    if (videoRef.current) {
      videoRef.current.srcObject = stream;
      await videoRef.current.play().catch(() => {});
    }
  };

 useEffect(() => {
  if (!ready) return;

  startCamera(facingMode);

  sideControlsTimerRef.current = setTimeout(() => {
    setShowSideControls(false);
  }, SIDE_CONTROLS_VISIBLE_MS);

  return () => {
    stopCamera();
    clearInterval(timerRef.current);
    clearTimeout(holdTimeoutRef.current);
    clearTimeout(sideControlsTimerRef.current);
  };
  // eslint-disable-next-line
}, [ready]);


  const switchCamera = () => {
    const next = facingMode === "user" ? "environment" : "user";
    setFacingMode(next);
    setShowSideControls(false);
    startCamera(next);
  };

  /* =======================
     ⚡ FLASH
  ======================= */
  
  /* =======================
     📸 PHOTO
  ======================= */
  const capturePhoto = () => {
    const video = videoRef.current;
    if (!video || !video.videoWidth) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);

    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        setMediaKind("photo");
        setMediaFile(blob);
        setPreviewURL(URL.createObjectURL(blob));
        stopCamera();
        setMode("preview");
      },
      "image/jpeg",
      0.95
    );
  };

  /* =======================
     🎬 VIDEO
  ======================= */
 const startRecording = async () => {

    if (!streamRef.current || recording) return;

    if (!streamRef.current?.getAudioTracks?.().length) {
  await startCamera(facingMode, true);
}


    setShowSideControls(false);
    chunksRef.current = [];
    setSecondsLeft(MAX_SECONDS);

    const recorder = new MediaRecorder(streamRef.current, {
      mimeType: "video/webm",
    });

    recorderRef.current = recorder;

    recorder.ondataavailable = (e) =>
      e.data.size && chunksRef.current.push(e.data);

    recorder.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: "video/webm" });
      if (!blob.size) return;

      setMediaKind("video");
      setMediaFile(blob);
      setPreviewURL(URL.createObjectURL(blob));
      stopCamera();
      setMode("preview");
    };

    recorder.start();
    setRecording(true);

    timerRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          stopRecording();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopRecording = () => {
    if (recorderRef.current?.state === "recording") {
      recorderRef.current.stop();
    }
    clearInterval(timerRef.current);
    setRecording(false);
  };

  /* =======================
     👆 PRESS
  ======================= */
  const handlePressStart = () => {
    holdTimeoutRef.current = setTimeout(startRecording, HOLD_THRESHOLD);
  };

  const handlePressEnd = () => {
    clearTimeout(holdTimeoutRef.current);
    recording ? stopRecording() : capturePhoto();
  };

  /* =======================
     🚀 SUBMIT
  ======================= */

  if (!currentUser?.id) {
  console.error("❌ No authenticated user found");
  navigate("/login", { replace: true });
  return;
}

  const handleSubmit = async () => {
 if (!mediaFile || lat === null || lng === null || !streetAddress) return;


  setLoading(true);

  const formData = new FormData();
formData.append("userId", currentUser.id);
formData.append("mediaType", mediaKind === "video" ? "video" : "image");
formData.append("caption", message.trim());

formData.append("streetAddress", streetAddress);
formData.append("lat", lat);
formData.append("lng", lng);
formData.append("media", mediaFile);

if (selectedCourseId) {
  formData.append("courseId", selectedCourseId);
}



  try {
    const res = await api.post("/posts", formData);

    setSuccessMessage(res.data.message || "LifeShot posted ✨");

    setMessage("");
   


   setTimeout(() => {
  setSuccessMessage("");

  // 🔔 update pulse
  window.dispatchEvent(new Event("pulse-updated"));

  // 🏠 let layout switch views (unmounts PostPage cleanly)
  window.dispatchEvent(new Event("go-home"));
}, 800);



  } catch (err) {
    console.error("Post failed", err);
  } finally {
    setLoading(false);
  }
};


  const progress = ((MAX_SECONDS - secondsLeft) / MAX_SECONDS) * 100;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "#000",
        overflow: "hidden",
        touchAction: "none",
        overscrollBehavior: "none",
      }}
    >
      
     <input
  ref={fileInputRef}
  type="file"
  accept="image/*,video/*"
  style={{ display: "none" }}
  onChange={(e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const kind = file.type.startsWith("video") ? "video" : "photo";

    setMediaKind(kind);
    setMediaFile(file);
    setPreviewURL(URL.createObjectURL(file));
    stopCamera();
    setMode("preview");
  }}
/>

{/* ✅ START GATE (asks once, after a tap) */}
{!ready && (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 50,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      px: 3,
      textAlign: "center",
      color: "#fff",
      bgcolor: "rgba(0,0,0,0.92)",
    }}
  >
    <Typography sx={{ fontWeight: 800, fontSize: "1.2rem" }}>
      Enable camera, mic & location
    </Typography>

    <Typography sx={{ color: "rgba(255,255,255,0.75)" }}>
      LifeShot needs these to capture moments and tag nearby.
    </Typography>

    <Button
      variant="contained"
      onClick={() => setReady(true)}
      sx={{ fontWeight: 800, borderRadius: 3 }}
    >
      Start
    </Button>
  </Box>
)}


      

          


      {mode === "camera" && (
        <Box sx={{ position: "absolute", inset: 0, zIndex: 1 }}>

          <video
            ref={videoRef}
            muted
            playsInline
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />

          <Box
            sx={{
              position: "relative",
             bottom: "max(120px, calc(64px + env(safe-area-inset-bottom)))",



              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
            }}
          >
            {showSideControls && (
                <IconButton
                  onClick={switchCamera}
                  sx={{
                    color: "#fff",
                    position: "absolute",
                    right: "calc(50% - 140px)", // 👈 controls distance from edge
  
                  }}
                >
                  <FlipCameraIosIcon />
                </IconButton>
              )}
              {showSideControls && (
            <IconButton
              onClick={() => fileInputRef.current?.click()}
              sx={{
                color: "#fff",
                position: "absolute",
                left: "calc(50% - 140px)", // 👈 symmetric with switch camera
              }}
            >
              <PhotoLibraryIcon />
            </IconButton>
          )}


            <Box
              onMouseDown={handlePressStart}
              onMouseUp={handlePressEnd}
              onTouchStart={handlePressStart}
              onTouchEnd={handlePressEnd}
              sx={{
                width: 86,
                height: 86,
                borderRadius: "50%",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {recording && (
                <CircularProgress
                  variant="determinate"
                  value={progress}
                  size={86}
                  thickness={4}
                  sx={{ position: "absolute", color: "#22C55E" }}
                />
              )}
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: recording ? "#DC2626" : "#fff",
                }}
              />
            </Box>

            
          </Box>
        </Box>
      )}

      {mode === "preview" && (
        <Box sx={{ position: "absolute", inset: 0 }}>
           {previewURL && (
              mediaKind === "video" ? (
                <video
                  src={previewURL}
                  autoPlay
                  loop
                  controls
                  playsInline
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <img
                  src={previewURL}
                  alt="Captured"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )
            )}


         <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,

                height: "50vh",                 // ✅ half the screen
                display: "flex",                // ✅ layout
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: 1.4,

                backdropFilter: "blur(16px)",
                background: "rgba(20,30,40,0.55)",

                px: 2,
                pt: 2,
                pb: "calc(18px + env(safe-area-inset-bottom))",

                // optional polish
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
              }}
            >

            <TextField
              fullWidth
              placeholder="Type your moment (optional)..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                mb: 1.4,
                background: "rgba(120,140,180,0.35)",
                borderRadius: "999px",
                "& fieldset": { border: "none" },
                "& input": { color: "#fff", padding: "14px 16px" },
              }}
            />

            <TextField
            select
            fullWidth
            label="Course (optional)"
            value={selectedCourseId}
            onChange={(e) => setSelectedCourseId(e.target.value)}
            sx={{
              mb: 1.4,
              background: "rgba(120,140,180,0.35)",
              borderRadius: 2,
              "& fieldset": { border: "none" },
              "& .MuiInputBase-input": { color: "#fff" },
              "& .MuiInputLabel-root": { color: "#E5E7EB" },
            }}
          >
            <MenuItem value="">
              None
            </MenuItem>

            {myCourses.map((c) => (
              <MenuItem key={c.id} value={String(c.id)}>
                {c.code} — {c.name}
              </MenuItem>
            ))}
          </TextField>


           <Typography sx={{ color: "#E5E7EB", mb: 1.6 }}>
        📍 {city ?? "Detecting location…"}
      </Typography>



            {successMessage && (
                <Typography
                  sx={{
                    color: "#A7F3D0",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 1.2,
                  }}
                >
                  {successMessage}
                </Typography>
              )}


            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}
              sx={{
                background: "#7ED9A8",
                color: "#0F172A",
                fontWeight: 700,
                borderRadius: 3,
                mb: 1,
              }}
            >
              {loading ? <CircularProgress size={22} /> : "Post"}
            </Button>

           
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default PostPage;
